import { InferType, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { currencyIdSchema, safeString } from './common';

interface PortalCryptoDepositSchemaParams {}

export const portalCryptoDepositSchema = (params: PortalCryptoDepositSchemaParams) => {
    return object({
        currencyId: currencyIdSchema('Deposit Currency cannot be empty!'),
        walletId: object({ label: safeString(), value: number() }).required('Please select a wallet.'),
        // amount value must be greater than 0
        amount: safeString()
            .test('amount', 'Amount must be more than 0', (value) => {
                return parseFloat(value || '0') > 0;
            })
            .required('Amount cannot be empty!'),
        requestDescription: safeString(),
        transactionHash: safeString()
    });
};

export type PortalCryptoDepositFormValues = InferType<ReturnType<typeof portalCryptoDepositSchema>>;
export type PortalCryptoDepositFormInput = Nullable<PortalCryptoDepositFormValues>;
